import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMG: CultureInfo = {
  name: 'en-MG',
  displayName: 'English (Madagascar)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MG',
  parent: CultureInfoEn
};
